if ($(".announcement-bar-section")[0]){
    // Do something if class exists
  $("body .navHeader").addClass("announceInView");
  $("body .navHeader ul li:last-of-type").addClass("announceInViewBasketIcon");
} else {
    // Do something if class does not exist
  $("body .navHeader").removeClass("announceInView");
  $("body .navHeader ul li:last-of-type").removeClass("announceInViewBasketIcon");
}